import React from "react";
import { Link } from "react-router-dom";

import { AppButton } from "../utils";
import drishtiLogo from "../assets/drishtiLogo.svg";

function Navbar() {
  return (
    <div className="flex justify-between items-center py-10">
      <div>
        <Link to="/">
          <img src={drishtiLogo} alt="drishti logo" />
        </Link>
      </div>
      <div className="flex items-center font-semibold space-x-4 ">
        <Link to="/about">
          <h2 className="menuitem hover:text-mix-400 px-4 py-2 rounded-full hover:scale-110 transition-all duration-200 ease-out cursor-pointer">
            About Us
            <span></span>
          </h2>
        </Link>
        <Link to="/events-listing">
          <h2 className="menuitem hover:text-mix-400 px-4 py-2 rounded-full hover:scale-110 transition-all duration-200 ease-out cursor-pointer">
            Events
            <span></span>
          </h2>
        </Link>
        {/* <h2 className="menuitem hover:text-mix-400 px-4 py-2 rounded-full hover:scale-110 transition-all duration-200 ease-out cursor-pointer">
          Contact Us
          <span></span>
        </h2> */}
        <Link to="/donate">
          <AppButton text="Donate" />
        </Link>
      </div>
    </div>
  );
}

export default Navbar;
